import React from 'react';
import dynamic from 'next/dynamic';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

import PropTypes from 'prop-types';

// Components
import Tooltip from '@/components/base/Tooltip';
import SocialMediaEventInfoPopover from '@/components/pages/scheduler/calendar/social-media-events/SocialMediaEventInfoPopover';
const DeleteSocialMediaEventModal = dynamic(
    () =>
        import(
            '@/components/pages/scheduler/calendar/social-media-events/DeleteSocialMediaEventModal'
        )
);
const CreateSocialMediaEventModal = dynamic(
    () =>
        import(
            '@/components/pages/scheduler/calendar/social-media-events/CreateSocialMediaEventModal'
        )
);

const SocialMediaEvent = ({ event, userDateFormatSettings, notEditable = false }) => {
    const { isOpen: isOpenDeleteModal, toggle: toggleDeleteModal } = useToggle();
    const { isOpen: isOpenCreateModal, toggle: toggleEditModal } = useToggle();
    return (
        <div className="px-0.5 pt-0.5">
            <SocialMediaEventInfoPopover
                userDateFormatSettings={userDateFormatSettings}
                toggleDeleteModal={toggleDeleteModal}
                toggleEditModal={toggleEditModal}
                notEditable={notEditable}
                event={event}>
                <Tooltip
                    content={
                        <div>
                            {event.title}
                            <br />
                            <div className="flex flex-wrap justify-center space-x-1">
                                {event.hashtags.map((hashtag, index) => {
                                    return <span key={index}>{hashtag}</span>;
                                })}
                            </div>
                        </div>
                    }>
                    <div className="relative flex w-full rounded-m bg-icoBlue-100 px-2.5 py-2 text-xxs text-icoBlue dark:bg-icoBlue/20">
                        <span className="block overflow-hidden text-ellipsis">{event.title}</span>
                    </div>
                </Tooltip>
            </SocialMediaEventInfoPopover>
            {!notEditable && (
                <>
                    <DeleteSocialMediaEventModal
                        isOpen={isOpenDeleteModal}
                        toggle={toggleDeleteModal}
                        event={event}
                    />
                    <CreateSocialMediaEventModal
                        event={event}
                        isOpen={isOpenCreateModal}
                        toggle={toggleEditModal}
                    />
                </>
            )}
        </div>
    );
};

SocialMediaEvent.propTypes = {
    event: PropTypes.object.isRequired
};

export default SocialMediaEvent;
